import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-100 pt-16 pb-8" data-id="element-4">
      <div className="container mx-auto px-4 md:px-6" data-id="element-5">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-6">
          <div className="col-span-1 md:col-span-1" data-id="element-7">
            <div className="flex items-center space-x-2 mb-4" data-id="element-8">
              <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center" data-id="element-9">
                <span className="text-cyan-500 font-bold text-xl" data-id="element-10">R</span>
              </div>
              <span className="font-bold text-xl text-slate-900" data-id="element-11">
                Remote Systems
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed" data-id="element-12">
              Building the next generation of consumer software products.
            </p>
          </div>

          <div data-id="element-13">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-14">Products</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-15">
              <li data-id="element-16">
                <a href="https://caltalk.ai" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-600 transition-colors" data-id="element-17">
                  Caltalk AI
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-18">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-19">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-20">
              <li data-id="element-21">
                <a href="#privacy" className="hover:text-cyan-600 transition-colors" data-id="element-22">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-23">
                <a href="#terms" className="hover:text-cyan-600 transition-colors" data-id="element-24">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8" data-id="element-25">
          <p className="text-sm text-slate-500 text-center" data-id="element-26">
            © {new Date().getFullYear()} Remote Systems Inc. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}